import { IMAGE_MOBILE, IMAGE_DESKTOP } from '../elements/assets'
import { LINK_TITLE } from '../elements/link'

export const CHAPTER_LIST = `
...on chapterList_Entry {
  id
  typeHandle
  
  headingAdvanced {
    html
  }
  description

  chapterListItems {
    id
    subTitle
    title
    description
    ${ LINK_TITLE }
    linkDescription

    ${ IMAGE_DESKTOP }
    ${ IMAGE_MOBILE }
  }

}
`